import Icon from "@material-ui/icons/Person";
import UserList from "./UserList";
import UserCreate from "./UserCreate";
import UserEdit from "./UserEdit";
import UserShow from "./UserShow";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "users",
  list: UserList,
  show: UserShow,
  edit: UserEdit,
  create: UserCreate,
  icon: Icon,
};
